<template>
    <div>
        <v-chip v-if="badge" light color="primary" small>{{ badge }}</v-chip>
        <h1>{{ title }}
            <span v-if="icon" class="help-btn" v-b-toggle.sidebar-right> 
            <v-icon style="z-index: 1;">mdi-help-circle</v-icon> 
            Details
        </span>
        </h1>
    </div>
</template>
<script>
export default {
    name: "PageHeader",
    props:{
        title: String,
        badge: String,
        icon: Boolean
    }
}
</script>

<!-- STYLE NOT SCOPED! -->
<style scoped>
.help-btn{
    font-size:1rem;
    vertical-align: middle;
}
.help-btn:hover >*, .help-btn:hover{
color:#0E7AFF !important;
}
.v-icon{
    font-size: 1.2em;
}
</style>
